const WEBMAIL_HELP_PAGES: Readonly<Record<string, string>> = {
  '/': 'webmail',
  '/search': 'search',
  '/calendar': 'calendar-contacts-tasks',
  '/contacts': 'contacts',
  '/tasks': 'tasks',
  '/folders': 'shared-mailboxes',
  '/settings': 'signatures',
  '/settings/automatic-replies': 'out-of-office',
};

const WEBMAIL_HELP_FALLBACK = '/docs/user/start-here/';

/** Map a webmail route to a published user page, never including URL state in the help link. */
export function webmailHelpHref(pathname: string, searchContextActive = false): string {
  if (pathname === '/' && searchContextActive) return '/docs/user/search/';
  const route = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const page = Object.entries(WEBMAIL_HELP_PAGES)
    .filter(([path]) => route === path || route.startsWith(`${path}/`))
    .sort(([left], [right]) => right.length - left.length)[0]?.[1];
  return page ? `/docs/user/${page}/` : WEBMAIL_HELP_FALLBACK;
}
